import React from 'react';
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { useTranslation } from 'react-i18next';

import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination } from 'swiper/modules';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import Typography from '@mui/material/Typography';

import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';
import LokalWorkers from "../snippets/LokalWorkers";

import Header from "./common/Header";

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'animate.css';


const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  	...theme.typography.body2,
  	padding: theme.spacing(1),
  	textAlign: 'center',
  	color: theme.palette.text.secondary,
}));

function StartContent(props) {

  	let navigate = useNavigate(); 
	const { t, i18n } = useTranslation("",{lng: props.language});


	const callUrl = (url) => {
		navigate(url);
	};
	
	const [ref0, inView0] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const [ref1, inView1] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const [ref2, inView2] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});	
	
	const [ref3, inView3] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	

  	return (<>
	  			<Box>
					<Header embedded={props.props.embedded} logo="logo.png"/>
	  			</Box>

				<Box sx={{ flexGrow: 1, display: {
							xs: 'block',
							sm: 'none',  
							md: 'none',  
							lg: 'none',  
							xl: 'none',  							
							} }}
				>

	  				<Box sx={{paddingTop: "0px", marginTop: "40px"}}> 
						<center>
							<h2 style={{paddingTop: "40px"}} class="headlineNewPoint">{t("StartPageHeader")}</h2>
						</center>

			      		<Grid container style={{paddingTop: "10px"}}>
			        		<Grid item xs={12}>
					      		<Grid container spacing={2}>
					        		<Grid item xs={1}>
						     	   </Grid>
					        		<Grid item xs={10}>
										<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}}>
											<Box  style={{color: "#000"}}>					
												<Box sx={{paddingLeft: "5px"}} >											        
											        <Typography variant="body2" color="text.secondary" sx={{fontSize: "1.2em"}}>
														<ul class="empty" sx={{listStyleType: "none"}}>
															<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>
																<b>
																	<strong>{t("StartPageUsp1")}</strong>
																</b>
															</li>

															<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>
																<b>
																	<strong>{t("StartPageUsp2")}</strong>
																</b>
															</li>

															<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>
																<b>
																	<strong>{t("StartPageUsp3")}</strong>
																</b>
															</li>


															<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>
																<b>
																	<strong>{t("StartPageUsp4")}</strong>
																</b>
															</li>



															<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>
																<b>
																	<strong>{t("StartPageUsp5")}</strong>
																</b>
															</li>
														</ul>											        			
											        </Typography>
												</Box>			
											</Box>			
										</Box>	
						     	   	</Grid>
					        		
					        		<Grid item xs={1}>
						     	   </Grid>
					     	   </Grid>
				     	   </Grid>
			     	   	</Grid>
			     	   	
			     	   	
						<Grid container style={{paddingTop: "10px"}}>
			        		<Grid item xs={12}>
					      		<Grid container spacing={2}>
					        		<Grid item xs={1}>
						     	   </Grid>
					        		<Grid item xs={10}>
										<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
											<Box  style={{textAlign: "justify", color: "#000"}}>					
												<p class="altFliessText" style={{margin: 0}}>{t("StartPageIntroText")}</p>
											</Box>			
										</Box>	
						     	   	</Grid>
					        		
					        		<Grid item xs={1}>
						     	   </Grid>
					     	   </Grid>
				     	   </Grid>
			     	   	</Grid>			     	   				     	   	
					</Box>
					<hr className="spacer"/>
					<LokalWorkers/>
					
					
<Box sx={{paddingTop: "40px"}}> 
							<Box class="fixBG">					
								<Box sx={{paddingTop: "20px",paddingBottom: "10px", textAlign: "center"}}>				
								<h2 class="highlightText headlineNewPoint" style={{color: "#dfdfdf"}}>{t("testimonials")}</h2>
							</Box>
							<Grid container style={{paddingBottom: "20px"}}>
				        		<Grid item xs={12}>
						      		<Grid container spacing={2}>
						        		<Grid item xs={2}>
							     	   </Grid>
						        		<Grid item xs={8}>
								      		<Grid container >
								        		<Grid item xs={12}>
										      		<Grid container spacing={2}>
										        		<Grid item xs={12}>
										        		
															<Swiper
																breakpoints={{
																    // when window width is >= 640px
																    640: {
																      width: 640,
																      slidesPerView: 1,
																    },
																    // when window width is >= 768px
																    768: {
																      width: 768,
																      slidesPerView: 2,
																    },
																    1024: {
																      width: 1024,
																      slidesPerView: 3,
																    },
																  }}															        
				  													spaceBetween={30}
															        freeMode={true}
															        pagination={{
															          clickable: true,
															        }}
															        modules={[FreeMode, Pagination]}
															        className="carsSwiper1"
															        style={{minHeight: "340px"}}
															      >
														        	<SwiperSlide>
																		<figure class="snip1390" style={{backgroundColor: "#747474", padding: "10px", borderRadius: "5px", width: "80%"}}>
																		  <figcaption>
																		  
																		    <h4>Projekt: Hausverwaltung</h4>
																		    <blockquote>„Endlich eine Hausverwaltung, die man auch nach Büroschluss erreichen kann!“</blockquote>
																		  </figcaption>
																		</figure>
														        	</SwiperSlide>
														        	<SwiperSlide>
																		<figure class="snip1390" style={{backgroundColor: "#747474", padding: "10px", borderRadius: "5px", width: "80%"}}>
																		  <figcaption>
																		  
																		    <h4>Projekt: Hausverwaltung</h4>
																		    <blockquote>„Als unsere Heizung ausfiel, war nicht nur die Hausverwaltung am Wochenende persönlich erreichbar, sondern sie organisierte auch noch den Handwerker für den gleichen Tag. Perfektes Team!“</blockquote>
																		  </figcaption>
																		</figure>
														        	</SwiperSlide>
														        	<SwiperSlide>
																		<figure class="snip1390" style={{backgroundColor: "#747474", padding: "10px", borderRadius: "5px", width: "80%"}}>
																		  <figcaption>
																		  
																		    <h4>Projekt: Hausverwaltung</h4>
																		    <blockquote>„Nach schlechten Erfahrungen mit anderen Verwaltungen fühlen wir uns jetzt gut betreut und informiert in allen Fragen.“</blockquote>
																		  </figcaption>
																		</figure>
														        	</SwiperSlide>
														        	<SwiperSlide>
																		<figure class="snip1390" style={{backgroundColor: "#747474", padding: "10px", borderRadius: "5px", width: "80%"}}>
																		  <figcaption>
																		  
																		    <h4>Projekt: Hausverwaltung</h4>
																		    <blockquote>„Hier ist man als WEG in guten Händen: Erreichbare, kompetente und freundliche Hausverwaltung!“</blockquote>
																		  </figcaption>
																		</figure>
														        	</SwiperSlide>
														        	<SwiperSlide>
																		<figure class="snip1390" style={{backgroundColor: "#747474", padding: "10px", borderRadius: "5px", width: "80%"}}>
																		  <figcaption>
																		  
																		    <h4>Projekt: Hausverwaltung</h4>
																		    <blockquote>„Wir schätzen es, unsere Versammlungen auch am Wochenende durchführen zu können. In der heutigen Zeit eine Seltenheit!“</blockquote>
																		  </figcaption>
																		</figure>
														        	</SwiperSlide>
															</Swiper>								
										        		

											     	   </Grid>
										     	   </Grid>
									     	   </Grid>
								     	   </Grid>
							     	   </Grid>
						        		<Grid item xs={2}>
							     	   </Grid>
						     	   </Grid>
					     	   </Grid>
				     	   	</Grid>				
						</Box>
	   				</Box>					
					
					
					
				</Box>

				<Box sx={{ flexGrow: 1, display: {
							xs: 'none',
							sm: 'none',  
							md: 'block',  
							lg: 'block',  
							xl: 'block',  							
							} }}
				>

	  				<Box sx={{paddingTop: "0px", marginTop: "40px"}}> 
						<center>
							<h2 style={{paddingTop: "40px"}} class="headlineNewPoint">{t("StartPageHeader")}</h2>
						</center>

			      		<Grid container style={{paddingTop: "40px"}}>
			        		<Grid item xs={12}>
					      		<Grid container spacing={2}>
					        		<Grid item xs={1}>
						     	   </Grid>
					        		<Grid item xs={5}>
										<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}}>
											<Box  style={{color: "#000"}}>					
												<Box sx={{paddingLeft: "50px"}} >											        
											        <Typography variant="body2" color="text.secondary" sx={{fontSize: "1.2em"}}>
														<ul class="empty" sx={{listStyleType: "none"}}>
															<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>
																<b>
																	<strong>{t("StartPageUsp1")}</strong>
																</b>
															</li>

															<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>
																<b>
																	<strong>{t("StartPageUsp2")}</strong>
																</b>
															</li>

															<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>
																<b>
																	<strong>{t("StartPageUsp3")}</strong>
																</b>
															</li>


															<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>
																<b>
																	<strong>{t("StartPageUsp4")}</strong>
																</b>
															</li>



															<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>
																<b>
																	<strong>{t("StartPageUsp5")}</strong>
																</b>
															</li>
														</ul>											        			
											        </Typography>
												</Box>			
											</Box>			
										</Box>	
						     	   	</Grid>
					        		<Grid item xs={5} sx={{	display: "flex",
															flexDirection: "row",
															justifyContent: "end",
															alignItems: "flex-end"}}
									>
										<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
											<Box  style={{textAlign: "justify", color: "#000"}}>					
												<p class="altFliessText" style={{margin: 0}}>{t("StartPageIntroText")}</p>
											</Box>			
										</Box>	
						     	   	</Grid>
					        		<Grid item xs={1}>
						     	   </Grid>
					     	   </Grid>
				     	   </Grid>
			     	   	</Grid>
					</Box>
					<hr className="spacer"/>

					<LokalWorkers/>
	
		  				<Box sx={{paddingTop: "40px", paddingTop: "40px", display: {
																		xs: 'none',
																		sm: 'none',  
																		md: 'block',  
																		lg: 'block',  
																		xl: 'block',  																		
																		}}}> 
		  				
		  				
							

						</Box>
	
		  				<Box sx={{paddingTop: "40px", paddingTop: "40px", display: {
																		xs: 'block',
																		sm: 'block',  
																		md: 'none',  
																		lg: 'none',  
																		xl: 'none',  																		
																		}}}> 
							<Box sx={{paddingTop: "0px"}}>
							</Box>	
						</Box>
	
		  				
		  				<Box sx={{paddingTop: "40px"}}> 
							<Box class="fixBG">					
								<Box sx={{paddingTop: "20px",paddingBottom: "10px", textAlign: "center"}}>				
								<h2 class="highlightText headlineNewPoint" style={{color: "#dfdfdf"}}>{t("testimonials")}</h2>
							</Box>
							<Grid container style={{paddingBottom: "20px"}}>
				        		<Grid item xs={12}>
						      		<Grid container spacing={2}>
						        		<Grid item xs={2}>
							     	   </Grid>
						        		<Grid item xs={8}>
								      		<Grid container >
								        		<Grid item xs={12}>
										      		<Grid container spacing={2}>
										        		<Grid item xs={12}>
										        		
															<Swiper
																breakpoints={{
																    // when window width is >= 640px
																    640: {
																      width: 640,
																      slidesPerView: 1,
																    },
																    // when window width is >= 768px
																    768: {
																      width: 768,
																      slidesPerView: 2,
																    },
																    1024: {
																      width: 1024,
																      slidesPerView: 3,
																    },
																  }}															        
				  													spaceBetween={30}
															        freeMode={true}
															        pagination={{
															          clickable: true,
															        }}
															        modules={[FreeMode, Pagination]}
															        className="carsSwiper1"
															        style={{minHeight: "340px"}}
															      >
														        	<SwiperSlide>
																		<figure class="snip1390" style={{backgroundColor: "#747474", padding: "10px", borderRadius: "5px", width: "80%"}}>
																		  <figcaption>
																		  
																		    <h4>Projekt: Hausverwaltung</h4>
																		    <blockquote>„Endlich eine Hausverwaltung, die man auch nach Büroschluss erreichen kann!“</blockquote>
																		  </figcaption>
																		</figure>
														        	</SwiperSlide>
														        	<SwiperSlide>
																		<figure class="snip1390" style={{backgroundColor: "#747474", padding: "10px", borderRadius: "5px", width: "80%"}}>
																		  <figcaption>
																		  
																		    <h4>Projekt: Hausverwaltung</h4>
																		    <blockquote>„Als unsere Heizung ausfiel, war nicht nur die Hausverwaltung am Wochenende persönlich erreichbar, sondern sie organisierte auch noch den Handwerker für den gleichen Tag. Perfektes Team!“</blockquote>
																		  </figcaption>
																		</figure>
														        	</SwiperSlide>
														        	<SwiperSlide>
																		<figure class="snip1390" style={{backgroundColor: "#747474", padding: "10px", borderRadius: "5px", width: "80%"}}>
																		  <figcaption>
																		  
																		    <h4>Projekt: Hausverwaltung</h4>
																		    <blockquote>„Nach schlechten Erfahrungen mit anderen Verwaltungen fühlen wir uns jetzt gut betreut und informiert in allen Fragen.“</blockquote>
																		  </figcaption>
																		</figure>
														        	</SwiperSlide>
														        	<SwiperSlide>
																		<figure class="snip1390" style={{backgroundColor: "#747474", padding: "10px", borderRadius: "5px", width: "80%"}}>
																		  <figcaption>
																		  
																		    <h4>Projekt: Hausverwaltung</h4>
																		    <blockquote>„Hier ist man als WEG in guten Händen: Erreichbare, kompetente und freundliche Hausverwaltung!“</blockquote>
																		  </figcaption>
																		</figure>
														        	</SwiperSlide>
														        	<SwiperSlide>
																		<figure class="snip1390" style={{backgroundColor: "#747474", padding: "10px", borderRadius: "5px", width: "80%"}}>
																		  <figcaption>
																		  
																		    <h4>Projekt: Hausverwaltung</h4>
																		    <blockquote>„Wir schätzen es, unsere Versammlungen auch am Wochenende durchführen zu können. In der heutigen Zeit eine Seltenheit!“</blockquote>
																		  </figcaption>
																		</figure>
														        	</SwiperSlide>
															</Swiper>								
										        		

											     	   </Grid>
										     	   </Grid>
									     	   </Grid>
								     	   </Grid>
							     	   </Grid>
						        		<Grid item xs={2}>
							     	   </Grid>
						     	   </Grid>
					     	   </Grid>
				     	   	</Grid>				
						</Box>
	   				</Box>

						<center>
							<h2 style={{paddingTop: "40px"}} class="headlineNewPoint">{t("StartPageSlogan2")}</h2>
						</center>
										
			      		<Grid container style={{paddingTop: "40px", paddingBottom: "40px"}}>
				        		<Grid item xs={12}>
						      		<Grid container spacing={2}>
						        		<Grid item xs={0} sm={0} md={1} lg={1} xl={2}>
							     	   </Grid>
						        		<Grid item xs={12} sm={12} md={10} lg={10} xl={8}>
											<Box sx={{	border: "2px solid black", 
														padding: "10px", 
														borderRadius: "5px", 
														display: { 	xs: 'none',
																	sm: 'block',  
																	md: 'block',  
																	lg: 'block',  
																	xl: 'block',  																		
																}
													}}
												>
												<ReactCompareSlider portrait={false}
												  ref={{
												    current: '[Circular]'
												  }}
												  boundsPadding={0}
												  itemOne={<ReactCompareSliderImage alt="Image one" src="/assets/AdobeStock_414193633.jpeg"/>}
												  itemTwo={<ReactCompareSliderImage alt="Image two" src="/assets/johanniskloster.jpg" style={{backgroundColor: 'white', backgroundImage: '\n linear-gradient(45deg, #ccc 25%, transparent 25%),\n linear-gradient(-45deg, #ccc 25%, transparent 25%),\n linear-gradient(45deg, transparent 75%, #ccc 75%),\n linear-gradient(-45deg, transparent 75%, #ccc 75%)', backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px', backgroundSize: '20px 20px'}}/>}
												  keyboardIncrement="5%"
												  position={50}
												  style={{
												    height: '60vh',
												    width: '100%'
												  }}
												  transition=".75s ease-in-out"
												/>
											</Box>
											<Box sx={{	border: "2px solid black", 
														padding: "10px", 
														borderRadius: "5px", display: {
																		xs: 'block',
																		sm: 'none',  
																		md: 'none',  
																		lg: 'none',  
																		xl: 'none',  
																		
																		}}}
												>
												<ReactCompareSlider portrait={false}
												  ref={{
												    current: '[Circular]'
												  }}
												  boundsPadding={0}
												  itemOne={<ReactCompareSliderImage alt="Image one" src="/assets/basecars/sliderinnen.jpg"/>}
												  itemTwo={<ReactCompareSliderImage alt="Image two" src="/assets/basecars/slideraussen.jpg" style={{backgroundColor: 'white', backgroundImage: '\n linear-gradient(45deg, #ccc 25%, transparent 25%),\n linear-gradient(-45deg, #ccc 25%, transparent 25%),\n linear-gradient(45deg, transparent 75%, #ccc 75%),\n linear-gradient(-45deg, transparent 75%, #ccc 75%)', backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px', backgroundSize: '20px 20px'}}/>}
												  keyboardIncrement="5%"
												  position={50}
												  style={{
												    height: '30vh',
												    width: '100%'
												  }}
												  transition=".75s ease-in-out"
												/>
											</Box>
							     	   </Grid>
						        		<Grid item xs={0} sm={0} md={1} lg={1} xl={2}>
							     	   </Grid>
						     	   </Grid>
					     	   </Grid>
			     	   	</Grid>	
   			</Box>
   		</>
   	)
}

export default function StartPage(props) {

  return <StartContent props={props}/>;
}